import React, { Component } from 'react';
import './App.css';
import OpenTrivia from 'opentrivia-react'

class App extends Component {
  constructor (props) {
    super(props);
    this.state = {
    }
  }

  answerSelectedClick(i, ans) {
    // Update the dom to show selected answer
    let answer;
    document.querySelectorAll('.otAnswer').forEach((el) => {
      el.style.backgroundColor = 'transparent';
      el.style.color = '#666';
    })
    answer = document.getElementById("ot-answer-" + i);
    answer.style.backgroundColor = '#CCD9E3';
    answer.style.color = 'white';

    console.log('Selected Answer = ', ans);
  }

  answerButtonClick (correctAns) {
    console.log('Clicked answer button, correct answer =', correctAns);
  }

  render() {
    return (
      <div className="App">
        <OpenTrivia
            amount={45}
            getToken={true}
            answerSelectedClicked={this.answerSelectedClick}
            answerButtonClicked={this.answerButtonClick}
        />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js